import React from 'react';
import PropTypes from 'prop-types';
import {
  formatGradePercent,
  formatGradePoints,
  getOutOfLabel,
  shouldShowPointDecimals,
  GRADEBOOK_SETTINGS,
} from './utils';
import styles from './GradeCell.module.css';

export function GradeCell({
  grade,
  showPercent,
  roundPercentType,
  settings,
  showOutOf,
}) {
  let content;

  if (showPercent) {
    content = formatGradePercent(
      grade?.studentGrade,
      grade,
      settings,
      roundPercentType,
    );
  } else {
    const points = formatGradePoints(grade, settings);
    const showDecimals = shouldShowPointDecimals(grade);
    const outOf = showOutOf
      ? getOutOfLabel(grade?.assigned_points, showDecimals)
      : null;
    content = (
      <>
        <span className={styles.pointsValue}>{points}</span>
        {outOf && <small className={styles.outOf}>{outOf}</small>}
      </>
    );
  }

  const containerClasses = [styles.container, styles.normal].join(' ');

  return (
    <div className={containerClasses}>
      {content}
      {grade?.isDropped && <span className={styles.dropped}>Dropped</span>}
    </div>
  );
}

GradeCell.propTypes = {
  grade: PropTypes.shape({
    studentGrade: PropTypes.number,
    studentPoints: PropTypes.number,
    assigned_points: PropTypes.number,
    isDropped: PropTypes.bool,
    isAssigned: PropTypes.bool,
    status: PropTypes.string,
    tool: PropTypes.string,
    subtype: PropTypes.string,
    grading_type: PropTypes.number,
  }),
  showPercent: PropTypes.bool,
  roundPercentType: PropTypes.number,
  settings: PropTypes.array,
  showOutOf: PropTypes.bool,
};

GradeCell.defaultProps = {
  grade: null,
  showPercent: true,
  roundPercentType: GRADEBOOK_SETTINGS.roundPercentWhole,
  settings: [],
  showOutOf: false,
};

export default GradeCell;
